import React from "react";
import { useSelector } from "react-redux";
import { cejnToast, shareCart } from "../../api/api";

export default function ShareInquiryForm(props) {
  const cart = useSelector((state) => state.cartData.cart);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);

  const [myName, setMyName] = React.useState("");
  const [myEmail, setMyEmail] = React.useState("");
  const [receiverName, setReceiverName] = React.useState("");
  const [receiverEmail, setReceiverEmail] = React.useState("");
  const [message, setMessage] = React.useState("");

  const requiredFields = [myName, myEmail, receiverName, receiverEmail];

  const resetValues = () => {
    setMyName("");
    setMyEmail("");
    setReceiverName("");
    setReceiverEmail("");
    setMessage("");
  };

  const submitForm = async (e) => {
    setLoading(true);
    e.preventDefault();

    if (requiredFields.some((x) => x.toString().trim() === "")) {
      cejnToast(i18n.getString("cejnToast.errors.invalidForm"), "ERROR");
      return;
    }

    let data = await shareCart({ message, myName, myEmail, receiverName, receiverEmail, cart });
    if (!data?.status.success) {
      setError(true);
      cejnToast(data.status.message ?? i18n.getString("cejnToast.errors.submitForm"), "ERROR");
      setLoading(false);
      return;
    }

    setLoading(false);
    resetValues();

    props.hideForm(data.status.message);
    cejnToast(data.status.message, "SUCCESS", true);
  };

  return (
    <form className="c-share-form__container" onSubmit={submitForm}>
      <fieldset>
        {/* My name field */}
        <div>
          <label>{i18n.getString("shareInquiryForm.labels.myName")}</label>
          <input type="text" onChange={(e) => setMyName(e.target.value)} value={myName} required />
        </div>

        {/* My email field */}
        <div>
          <label>{i18n.getString("shareInquiryForm.labels.myEmail")}</label>
          <input type="email" onChange={(e) => setMyEmail(e.target.value)} value={myEmail} required />
        </div>

        {/* Receiver name field */}
        <div>
          <label>{i18n.getString("shareInquiryForm.labels.receiverName")}</label>
          <input type="text" onChange={(e) => setReceiverName(e.target.value)} value={receiverName} required />
        </div>

        {/* Receiver email field */}
        <div>
          <label>{i18n.getString("shareInquiryForm.labels.receiverEmail")}</label>
          <input type="email" onChange={(e) => setReceiverEmail(e.target.value)} value={receiverEmail} required />
        </div>
      </fieldset>

      <fieldset>
        <div>
          {/* Message field */}
          <label>{i18n.getString("shareInquiryForm.labels.message")}</label>
          <textarea onChange={(e) => setMessage(e.target.value)} value={message} />
        </div>
      </fieldset>

      <button className="c-flex-button__green">{i18n.getString("shareInquiryForm.labels.sendButton")}</button>
    </form>
  );
}
